// Party Packages - Shared JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Toast Notification System
  function createToastContainer() {
    let container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'toast-container';
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'true');
      document.body.appendChild(container);
    }
    return container;
  }

  function showToast(message, type = 'error') {
    const container = createToastContainer();
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.setAttribute('role', 'alert');

    const icons = {
      error: '⚠️',
      success: '✓',
      warning: '⚠️',
      info: 'ℹ️'
    };

    toast.innerHTML = `
      <span class="toast__icon">${icons[type] || icons.error}</span>
      <span class="toast__message">${message}</span>
      <button type="button" class="toast__close" aria-label="Close notification">&times;</button>
    `;

    container.appendChild(toast);

    // Close button handler
    const closeBtn = toast.querySelector('.toast__close');
    closeBtn.addEventListener('click', () => {
      dismissToast(toast);
    });

    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      dismissToast(toast);
    }, 5000);
  }

  function dismissToast(toast) {
    toast.classList.add('toast--hiding');
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }

  // Package Order Overlay System
  const packageOrderOverlay = document.getElementById('package-order-overlay');
  const packageOrderBody = packageOrderOverlay.querySelector('.package-order-overlay__body');
  const packageOrderFooter = packageOrderOverlay.querySelector('.package-order-overlay__footer');
  const packageOrderClose = packageOrderOverlay.querySelector('.package-order-overlay__close');
  const packageOrderBackdrop = packageOrderOverlay.querySelector('.package-order-overlay__backdrop');
  const packageNameHeader = packageOrderOverlay.querySelector('.package-order-overlay__package-name');
  const packageMetaHeader = packageOrderOverlay.querySelector('.package-order-overlay__package-meta');

  let currentPackageData = null;

  // Wizard state
  const WIZARD_PACKAGES = ['party-package-small', 'party-package-large'];
  let currentWizardStep = 0;

  // Scroll indicator cleanup
  let scrollIndicatorAbortController = null;

  // Order Package button clicks
  document.querySelectorAll('.order-package-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      openPackageOrderOverlay(this);
    });
  });

  function openPackageOrderOverlay(button) {
    currentPackageData = {
      packageId: button.dataset.packageId,
      packageName: button.dataset.packageName,
      packagePrice: button.dataset.packagePrice,
      packageServes: button.dataset.packageServes,
      variantId: button.dataset.variantId,
      choice1Label: button.dataset.choice1Label,
      choice1Type: button.dataset.choice1Type,
      choice1Max: button.dataset.choice1Max,
      choice1Options: button.dataset.choice1Options,
      choice1Upcharges: button.dataset.choice1Upcharges,
      choice2Label: button.dataset.choice2Label,
      choice2Type: button.dataset.choice2Type,
      choice2Max: button.dataset.choice2Max,
      choice2Options: button.dataset.choice2Options,
      choice2Upcharges: button.dataset.choice2Upcharges,
      choice3Label: button.dataset.choice3Label,
      choice3Type: button.dataset.choice3Type,
      choice3Max: button.dataset.choice3Max,
      choice3Options: button.dataset.choice3Options,
      choice3Upcharges: button.dataset.choice3Upcharges,
      choice4Label: button.dataset.choice4Label,
      choice4Type: button.dataset.choice4Type,
      choice4Max: button.dataset.choice4Max,
      choice4Options: button.dataset.choice4Options,
      choice4Upcharges: button.dataset.choice4Upcharges,
      productHandle: button.dataset.productHandle
    };

    // Update header
    packageNameHeader.textContent = currentPackageData.packageName;
    packageMetaHeader.innerHTML = `<strong>${currentPackageData.packagePrice}</strong>`;

    // Build form (wizard for small/large, single-page for others)
    if (WIZARD_PACKAGES.includes(currentPackageData.productHandle)) {
      buildWizardForm();
    } else {
      buildPackageForm();
    }

    // Add ARIA attributes
    packageOrderOverlay.setAttribute('role', 'dialog');
    packageOrderOverlay.setAttribute('aria-modal', 'true');
    packageOrderOverlay.setAttribute('aria-labelledby', 'package-order-title');

    // Show overlay
    packageOrderOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';

    // Initialize scroll indicator
    initScrollIndicator();

    // Set focus to close button for accessibility
    setTimeout(() => {
      packageOrderClose.focus();
    }, 100);
  }

  // Initialize scroll indicator for package overlay body
  function initScrollIndicator() {
    // Abort any previous listeners before attaching new ones
    if (scrollIndicatorAbortController) scrollIndicatorAbortController.abort();
    scrollIndicatorAbortController = new AbortController();
    const { signal } = scrollIndicatorAbortController;

    // Remove existing indicator if any
    const existingIndicator = packageOrderBody.querySelector('.package-order-overlay__scroll-indicator');
    if (existingIndicator) existingIndicator.remove();

    // Create scroll indicator
    const indicator = document.createElement('div');
    indicator.className = 'package-order-overlay__scroll-indicator hidden';
    indicator.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    `;
    indicator.setAttribute('aria-label', 'Scroll down for more options');
    packageOrderBody.appendChild(indicator);

    // Function to check if scrollable and update indicator
    function updateScrollIndicator() {
      const isScrollable = packageOrderBody.scrollHeight > packageOrderBody.clientHeight;
      const isAtBottom = packageOrderBody.scrollHeight - packageOrderBody.scrollTop <= packageOrderBody.clientHeight + 10;

      if (isScrollable && !isAtBottom) {
        indicator.classList.remove('hidden');

        // Position indicator using percentages for responsive placement
        indicator.style.top = '65%';
        indicator.style.right = '10%';
      } else {
        indicator.classList.add('hidden');
      }
    }

    // Update on scroll
    packageOrderBody.addEventListener('scroll', updateScrollIndicator, { signal });

    // Click handler to scroll down
    indicator.addEventListener('click', () => {
      packageOrderBody.scrollBy({
        top: 200,
        behavior: 'smooth'
      });
    });

    // Touch/swipe handler for mobile
    let touchStartY = 0;
    packageOrderBody.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true, signal });

    packageOrderBody.addEventListener('touchmove', (e) => {
      const touchEndY = e.touches[0].clientY;
      const deltaY = touchStartY - touchEndY;

      // If swiping down (deltaY > 0) and there's more content below
      if (deltaY > 30) {
        packageOrderBody.scrollBy({
          top: 100,
          behavior: 'smooth'
        });
      }
    }, { passive: true, signal });

    // Initial check after content loads
    setTimeout(updateScrollIndicator, 100);
  }

  function buildPackageForm() {
    let formHTML = `<form class="package-form" id="overlay-package-form" data-package-id="${currentPackageData.packageId}" data-variant-id="${currentPackageData.variantId}">`;

    // Choice 1
    if (currentPackageData.choice1Label) {
      formHTML += buildChoiceField(1, currentPackageData.choice1Label, currentPackageData.choice1Type, currentPackageData.choice1Max, currentPackageData.choice1Options, currentPackageData.choice1Upcharges);
    }

    // Choice 2
    if (currentPackageData.choice2Label) {
      formHTML += buildChoiceField(2, currentPackageData.choice2Label, currentPackageData.choice2Type, currentPackageData.choice2Max, currentPackageData.choice2Options, currentPackageData.choice2Upcharges);
    }

    // Choice 3
    if (currentPackageData.choice3Label) {
      formHTML += buildChoiceField(3, currentPackageData.choice3Label, currentPackageData.choice3Type, currentPackageData.choice3Max, currentPackageData.choice3Options, currentPackageData.choice3Upcharges);
    }

    // Choice 4
    if (currentPackageData.choice4Label) {
      formHTML += buildChoiceField(4, currentPackageData.choice4Label, currentPackageData.choice4Type || 'select', currentPackageData.choice4Max, currentPackageData.choice4Options, currentPackageData.choice4Upcharges);
    }

    // Add Ons section - placeholder, will be populated after product fetch
    formHTML += `
      <div class="package-form__section package-form__addons">
        <h3 class="package-form__section-title">Add Ons</h3>
        <div id="addon-items-container">
          <div class="addon-item-loading">Loading add-ons...</div>
        </div>
      </div>
    `;

    formHTML += `</form>`;

    packageOrderBody.innerHTML = formHTML;

    // Fetch and populate add-ons
    loadAddons();

    // Build footer with quantity and add to cart
    packageOrderFooter.innerHTML = `
      <div class="overlay-quantity-selector">
        <label for="overlay-quantity">Order
          <select id="overlay-quantity" name="quantity" aria-label="Package quantity">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <span id="package-plural">package</span>
        </label>
      </div>
      <div class="total-price-display" id="total-price-display" style="display: none;">
        <div class="total-price-display__row">
          <span class="total-price-display__label">Base Price:</span>
          <span class="total-price-display__value" id="base-price-value">${currentPackageData.packagePrice}</span>
        </div>
        <div class="total-price-display__row" id="upcharge-row" style="display: none;">
          <span class="total-price-display__label">Upcharge:</span>
          <span class="total-price-display__value" id="upcharge-value">+$0.00</span>
        </div>
        <div class="total-price-display__row total-price-display__row--total">
          <span class="total-price-display__label">Total:</span>
          <span class="total-price-display__value" id="total-price-value">${currentPackageData.packagePrice}</span>
        </div>
      </div>
      <button type="button" class="button button--primary button--full" id="overlay-add-to-cart" aria-label="Add package to cart">Add to Cart</button>
    `;

    // Re-initialize form handlers
    initializeOverlayFormHandlers();
  }

  // ─── Wizard UI (Small & Large packages only) ─────────────────────────────

  function getWizardStepConfig() {
    const choices = [1, 2, 3, 4]
      .map(n => ({
        num:       n,
        label:     currentPackageData[`choice${n}Label`],
        type:      currentPackageData[`choice${n}Type`] || 'select',
        max:       currentPackageData[`choice${n}Max`],
        options:   currentPackageData[`choice${n}Options`],
        upcharges: currentPackageData[`choice${n}Upcharges`]
      }))
      .filter(c => c.label);
    return {
      tapas:   choices.find(c => c.type === 'tapas-platter'),
      skewers: choices.find(c => c.type === 'skewer-builder'),
      selects: choices.filter(c => c.type === 'select' || c.type === 'dropdown-sequence')
    };
  }

  function buildWizardForm() {
    currentWizardStep = 0;
    const config = getWizardStepConfig();

    const step0HTML = config.tapas
      ? buildChoiceField(config.tapas.num, config.tapas.label, 'tapas-platter', config.tapas.max, config.tapas.options, config.tapas.upcharges)
      : '';
    const step1HTML = config.selects
      .map(c => buildChoiceField(c.num, c.label, c.type, c.max, c.options, c.upcharges))
      .join('');
    const step2HTML = config.skewers
      ? buildChoiceField(config.skewers.num, config.skewers.label, 'skewer-builder', config.skewers.max, config.skewers.options, config.skewers.upcharges)
      : '';
    const step3HTML = `
      <div class="package-form__section package-form__addons">
        <h3 class="package-form__section-title">Add Ons</h3>
        <div id="addon-items-container"><div class="addon-item-loading">Loading add-ons...</div></div>
      </div>`;

    packageOrderBody.innerHTML = `
      <form class="package-form" id="overlay-package-form"
            data-package-id="${currentPackageData.packageId}"
            data-variant-id="${currentPackageData.variantId}">
        <div class="wizard-progress">
          <div class="wizard-progress__label">Step 1 of 5: Tapas Selection</div>
          <div class="wizard-progress__bar">
            <div class="wizard-progress__fill" style="width:20%"></div>
          </div>
        </div>
        <div class="wizard-step-error" role="alert" style="display:none;"></div>
        <div class="wizard-step" data-step="0">${step0HTML}</div>
        <div class="wizard-step wizard-step--hidden" data-step="1">${step1HTML}</div>
        <div class="wizard-step wizard-step--hidden" data-step="2">${step2HTML}</div>
        <div class="wizard-step wizard-step--hidden" data-step="3">${step3HTML}</div>
        <div class="wizard-step wizard-step--hidden" data-step="4"></div>
      </form>`;

    renderWizardFooter();
    loadAddons();
    initializeOverlayFormHandlers();
    expandStepCollapsibles(0);
  }

  function getWizardStepNames() {
    return ['Tapas Selection', 'Salad & Side', 'Skewer Selection', 'Add Ons', 'Review'];
  }

  function updateWizardProgress() {
    const names = getWizardStepNames();
    const label = packageOrderBody.querySelector('.wizard-progress__label');
    const fill  = packageOrderBody.querySelector('.wizard-progress__fill');
    if (label) label.textContent = `Step ${currentWizardStep + 1} of 5: ${names[currentWizardStep]}`;
    if (fill)  fill.style.width  = `${(currentWizardStep + 1) / 5 * 100}%`;
  }

  function renderWizardFooter() {
    if (currentWizardStep === 4) {
      packageOrderFooter.innerHTML = `
        <div class="wizard-footer">
          <button type="button" class="wizard-back-btn button">&#8592; Back</button>
          <button type="button" class="button button--primary" id="overlay-add-to-cart">Add to Cart</button>
        </div>`;
    } else {
      packageOrderFooter.innerHTML = `
        <div class="wizard-footer">
          <button type="button" class="wizard-back-btn button${currentWizardStep === 0 ? ' wizard-back-btn--invisible' : ''}">&#8592; Back</button>
          <button type="button" class="wizard-next-btn button button--primary">Next &#8594;</button>
        </div>`;
    }
    packageOrderFooter.querySelector('.wizard-back-btn')?.addEventListener('click', () => navigateWizardStep(currentWizardStep - 1));
    packageOrderFooter.querySelector('.wizard-next-btn')?.addEventListener('click', () => navigateWizardStep(currentWizardStep + 1));
  }

  function showStepError(message) {
    const el = packageOrderBody.querySelector('.wizard-step-error');
    if (!el) return;
    el.textContent = message;
    el.style.display = 'block';
    setTimeout(() => { el.style.display = 'none'; }, 4000);
  }

  function validateWizardStep(step) {
    const stepEl = packageOrderBody.querySelector(`.wizard-step[data-step="${step}"]`);
    if (!stepEl) return true;

    if (step === 0) {
      const selector = stepEl.querySelector('.tapas-inline-selector');
      const max = parseInt(selector?.dataset.maxSelections || '0');
      const input = stepEl.querySelector('.tapas-selections-input');
      let total = 0;
      (input?.value || '').split(',').forEach(s => {
        const m = s.trim().match(/\((\d+)\)$/);
        total += m ? parseInt(m[1]) : (s.trim() ? 1 : 0);
      });
      if (total < max) {
        showStepError(`Please select ${max} tapas before continuing.`);
        return false;
      }
      return true;
    }

    if (step === 1) {
      const empties = [...stepEl.querySelectorAll('select[required]')].filter(s => !s.value);
      if (empties.length) {
        showStepError('Please make a selection for all fields before continuing.');
        return false;
      }
      return true;
    }

    if (step === 2) {
      const builder = stepEl.querySelector('.skewer-builder');
      if (!builder) return true;
      const max   = parseInt(builder.dataset.maxTotal || '0');
      const count = parseInt(builder.querySelector('.skewer-count')?.textContent || '0');
      if (count < max) {
        showStepError(`Please select all ${max} skewers before continuing.`);
        return false;
      }
      return true;
    }

    return true;
  }

  function expandStepCollapsibles(step) {
    const stepEl = packageOrderBody.querySelector(`.wizard-step[data-step="${step}"]`);
    if (!stepEl) return;
    stepEl.querySelectorAll('.collapsible-section').forEach(section => {
      const content = section.querySelector('.collapsible-section__content');
      section.classList.remove('collapsed');
      section.classList.add('expanded');
      // Use large fixed value instead of scrollHeight to avoid timing issues with
      // display:none ancestors. CSS transitions still work correctly collapse → 0px.
      if (content) content.style.maxHeight = '5000px';
    });
  }

  let wizardNavigating = false;

  function navigateWizardStep(targetStep) {
    if (wizardNavigating) return;
    if (targetStep < 0 || targetStep > 4) return;
    if (targetStep > currentWizardStep && !validateWizardStep(currentWizardStep)) return;

    const currentEl = packageOrderBody.querySelector(`.wizard-step[data-step="${currentWizardStep}"]`);
    const targetEl  = packageOrderBody.querySelector(`.wizard-step[data-step="${targetStep}"]`);
    if (!currentEl || !targetEl) return;

    // Generate review content before showing it
    if (targetStep === 4) generateReviewStep(targetEl);

    wizardNavigating = true;

    // Fade out current step
    currentEl.style.transition = 'opacity 0.2s ease';
    currentEl.style.opacity = '0';

    setTimeout(() => {
      currentEl.classList.add('wizard-step--hidden');
      currentEl.style.opacity = '';

      targetEl.classList.remove('wizard-step--hidden');
      targetEl.style.opacity = '0';
      targetEl.style.transition = 'opacity 0.2s ease';
      // Small timeout so display:block takes effect before opacity transition
      setTimeout(() => { targetEl.style.opacity = ''; }, 20);

      currentWizardStep = targetStep;
      updateWizardProgress();
      renderWizardFooter();
      expandStepCollapsibles(targetStep);
      packageOrderBody.scrollTop = 0;

      wizardNavigating = false;

      // Wire review step controls (quantity selector and add-to-cart)
      if (targetStep === 4) {
        const addToCartBtn = document.getElementById('overlay-add-to-cart');
        if (addToCartBtn) addToCartBtn.addEventListener('click', handleOverlayAddToCart);
        const qtySelect  = document.getElementById('overlay-quantity');
        const pluralSpan = document.getElementById('package-plural');
        if (qtySelect) {
          qtySelect.addEventListener('change', function() {
            const qty = parseInt(qtySelect.value);
            if (pluralSpan) pluralSpan.textContent = qty === 1 ? 'package' : 'packages';
            updateOverallUpcharge();
          });
        }
      }
    }, 200);
  }

  function generateReviewStep(stepEl) {
    const config = getWizardStepConfig();

    // Read tapas selections
    const tapasInput = packageOrderBody.querySelector('.tapas-selections-input');
    const tapasValue = tapasInput?.value || '(none selected)';
    const tapasLabel = config.tapas?.label || 'Tapas Selection';

    // Read salad & side selections
    const selectSummaries = config.selects.map(choice => {
      if (choice.type === 'dropdown-sequence') {
        const selects = packageOrderBody.querySelectorAll(`select[name^="choice_${choice.num}_item_"]`);
        const values = [];
        selects.forEach(s => { if (s.value) values.push(s.value); });
        return { label: choice.label, value: values.length ? values.join(', ') : '(none selected)' };
      }
      const select = packageOrderBody.querySelector(`select[name="choice_${choice.num}"]`);
      return { label: choice.label, value: select?.value || '(none selected)' };
    });

    // Read skewer selections
    const skewerSelections = [];
    packageOrderBody.querySelectorAll('.skewer-builder .skewer-qty-select').forEach(sel => {
      const qty = parseInt(sel.value) || 0;
      if (qty > 0) skewerSelections.push(`${qty}&times; ${sel.dataset.optionName}`);
    });
    const skewersLabel = config.skewers?.label || 'Skewer Selection';
    const skewersValue = skewerSelections.length ? skewerSelections.join(', ') : '(none selected)';

    // Read add-on selections
    const addOnParts = [];
    const dessertQty = parseInt(packageOrderBody.querySelector('#addon-dessert-plate')?.value || '0');
    if (dessertQty > 0) addOnParts.push(`${dessertQty}&times; Mixed Dessert Plate`);
    packageOrderBody.querySelectorAll('.additional-skewer-qty-select').forEach(sel => {
      const qty = parseInt(sel.value) || 0;
      if (qty > 0) {
        const name = sel.dataset.optionName.replace(/\s+Skewers?$/i, '');
        addOnParts.push(`${qty}&times; ${name} (additional)`);
      }
    });
    const addOnsValue = addOnParts.length ? addOnParts.join(', ') : 'None';

    // Calculate upcharge for price display
    let totalUpcharge = 0;
    packageOrderBody.querySelectorAll('.skewer-builder .skewer-qty-select').forEach(sel => {
      totalUpcharge += (parseInt(sel.value) || 0) * (parseFloat(sel.dataset.upcharge) || 0);
    });
    packageOrderBody.querySelectorAll('.additional-skewer-qty-select').forEach(sel => {
      totalUpcharge += (parseInt(sel.value) || 0) * (parseFloat(sel.dataset.price) || 0);
    });
    if (dessertQty > 0) {
      const dessertItem = packageOrderBody.querySelector('#addon-dessert-plate')?.closest('.addon-item');
      totalUpcharge += dessertQty * (parseFloat(dessertItem?.dataset.addonPrice) || 0);
    }

    const basePrice = parseFloat((currentPackageData.packagePrice || '0').replace(/[^0-9.]/g, '')) || 0;
    const upchargeDisplay = totalUpcharge > 0 ? `+$${totalUpcharge.toFixed(2)}` : '+$0.00';
    const totalDisplay = `$${(basePrice + totalUpcharge).toFixed(2)}`;

    stepEl.innerHTML = `
      <div class="wizard-review">
        <h3 class="wizard-review__title">Review Your Order</h3>

        <div class="wizard-review__section">
          <div class="wizard-review__row">
            <span class="wizard-review__section-label">${tapasLabel}</span>
            <button type="button" class="wizard-review__edit" data-goto-step="0">Edit</button>
          </div>
          <p class="wizard-review__detail">${tapasValue}</p>
        </div>

        ${selectSummaries.map(s => `
        <div class="wizard-review__section">
          <div class="wizard-review__row">
            <span class="wizard-review__section-label">${s.label}</span>
            <button type="button" class="wizard-review__edit" data-goto-step="1">Edit</button>
          </div>
          <p class="wizard-review__detail">${s.value}</p>
        </div>`).join('')}

        <div class="wizard-review__section">
          <div class="wizard-review__row">
            <span class="wizard-review__section-label">${skewersLabel}</span>
            <button type="button" class="wizard-review__edit" data-goto-step="2">Edit</button>
          </div>
          <p class="wizard-review__detail">${skewersValue}</p>
        </div>

        <div class="wizard-review__section">
          <div class="wizard-review__row">
            <span class="wizard-review__section-label">Add Ons</span>
            <button type="button" class="wizard-review__edit" data-goto-step="3">Edit</button>
          </div>
          <p class="wizard-review__detail">${addOnsValue}</p>
        </div>

        <div class="wizard-review__order-total">
          <div class="overlay-quantity-selector">
            <label for="overlay-quantity">Order
              <select id="overlay-quantity" name="quantity" aria-label="Package quantity">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              <span id="package-plural">package</span>
            </label>
          </div>
          <div class="total-price-display" id="total-price-display">
            <div class="total-price-display__row">
              <span class="total-price-display__label">Base Price:</span>
              <span class="total-price-display__value" id="base-price-value">${currentPackageData.packagePrice}</span>
            </div>
            <div class="total-price-display__row" id="upcharge-row"${totalUpcharge === 0 ? ' style="display:none;"' : ''}>
              <span class="total-price-display__label">Upcharge:</span>
              <span class="total-price-display__value" id="upcharge-value">${upchargeDisplay}</span>
            </div>
            <div class="total-price-display__row total-price-display__row--total">
              <span class="total-price-display__label">Total:</span>
              <span class="total-price-display__value" id="total-price-value">${totalDisplay}</span>
            </div>
          </div>
        </div>
      </div>`;

    // Wire edit links
    stepEl.querySelectorAll('.wizard-review__edit').forEach(btn => {
      btn.addEventListener('click', () => navigateWizardStep(parseInt(btn.dataset.gotoStep)));
    });

    // Pre-populate quantity from edit session
    if (window.packageEditSession?.quantity) {
      const qtyEl = stepEl.querySelector('#overlay-quantity');
      if (qtyEl) {
        qtyEl.value = window.packageEditSession.quantity;
        const pluralEl = stepEl.querySelector('#package-plural');
        if (pluralEl) pluralEl.textContent = window.packageEditSession.quantity > 1 ? 'packages' : 'package';
      }
    }
  }

  // ─── End Wizard UI ────────────────────────────────────────────────────────

  // Load add-ons with product data
  async function loadAddons() {
    const container = document.getElementById('addon-items-container');
    if (!container) return;

    container.innerHTML = '';

    // Load dessert plate
    try {
      const response = await fetch('/products/mixed-dessert-plate.js');
      if (!response.ok) throw new Error('Product not found');

      const product = await response.json();
      const price = product.variants[0].price / 100;
      const description = product.description || 'Assorted desserts';

      const dessertDiv = document.createElement('div');
      dessertDiv.className = 'addon-item';
      dessertDiv.dataset.addonPrice = price;
      dessertDiv.innerHTML = `
        <div class="addon-item__info">
          <label for="addon-dessert-plate" class="addon-item__name">${product.title}</label>
          <p class="addon-item__description">${description}</p>
          <p class="addon-item__price">$${price.toFixed(2)} each <span class="addon-item__total"></span></p>
        </div>
        <div class="addon-item__quantity">
          <label for="addon-dessert-plate" class="sr-only">Quantity of ${product.title}</label>
          <select id="addon-dessert-plate" name="addon_dessert_plate" class="addon-qty-select" aria-label="${product.title} quantity">
            <option value="0">None</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
      `;
      container.appendChild(dessertDiv);

      const select = document.getElementById('addon-dessert-plate');
      const totalSpan = dessertDiv.querySelector('.addon-item__total');

      select.addEventListener('change', () => {
        const qty = parseInt(select.value) || 0;
        if (qty > 1) {
          const total = price * qty;
          totalSpan.textContent = `(Total: $${total.toFixed(2)})`;
          totalSpan.style.display = 'inline';
        } else {
          totalSpan.textContent = '';
          totalSpan.style.display = 'none';
        }
        updateOverallUpcharge();
      });
    } catch (error) {
      console.error('Error loading dessert plate add-on:', error);
    }

    // Load additional skewers for small and large packages
    if (currentPackageData.productHandle === 'party-package-small' ||
        currentPackageData.productHandle === 'party-package-large') {
      const wizardConfig = getWizardStepConfig();
      await loadAdditionalSkewers(container, wizardConfig.skewers?.max || 0);
    }
  }

  // Load Additional Skewers collapsible section (small package only)
  async function loadAdditionalSkewers(container, includedMax) {
    try {
      const response = await fetch('/products/additional-skewers.js');
      if (!response.ok) return;

      const product = await response.json();

      // Build variant map: { "Chicken": { id, price }, ... }
      const variantMap = {};
      product.variants.forEach(variant => {
        variantMap[variant.title] = { id: variant.id, price: variant.price / 100 };
      });

      // Use same skewer options as the included skewer-builder (whichever choice it's on)
      const wizardConfig = getWizardStepConfig();
      const skewersOptions = wizardConfig.skewers?.options || '';
      const skewers = skewersOptions ? skewersOptions.split(',').map(o => o.trim()) : [];
      if (skewers.length === 0) return;

      // Build grid rows
      let gridHTML = '';
      skewers.forEach((option, index) => {
        const cleanLabel = option.replace(/\s+Skewers?$/i, '');
        const variantData = variantMap[cleanLabel];
        if (!variantData) return;

        const selectId = `additional-skewer-${cleanLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
        gridHTML += `
          <label for="${selectId}">${cleanLabel}<br><small>$${variantData.price.toFixed(0)}/each</small></label>
          <select id="${selectId}"
            class="additional-skewer-qty-select"
            data-option-name="${option}"
            data-variant-id="${variantData.id}"
            data-price="${variantData.price}"
            aria-label="Additional ${cleanLabel} quantity">
            <option value="0">0</option>`;
        for (let i = 1; i <= 30; i++) {
          gridHTML += `<option value="${i}">${i}</option>`;
        }
        gridHTML += `</select>`;
        if (index % 2 === 0 && index < skewers.length - 1) {
          gridHTML += `<div class="skewer-spacer"></div>`;
        }
      });

      const sectionDiv = document.createElement('div');
      sectionDiv.innerHTML = `
        <div class="collapsible-section addon-skewer-section" data-section-type="addon-skewer">
          <div class="collapsible-section__header">
            <h3 class="collapsible-section__title">Additional Skewers <span class="addon-skewer-subtext">beyond the ${includedMax} included</span></h3>
            <div class="collapsible-section__icons">
              <svg class="collapsible-section__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="collapsible-section__content" style="max-height: 0; overflow: hidden;">
            <div class="additional-skewer-builder">
              <div class="skewer-builder__grid">${gridHTML}</div>
              <p class="skewer-builder__status"><span class="additional-skewer-count">0</span> additional skewers selected</p>
            </div>
          </div>
        </div>
      `;
      container.appendChild(sectionDiv.firstElementChild);

      // Wire up collapsible toggle (matches initCollapsibleSections behaviour)
      const section = container.querySelector('.addon-skewer-section');
      const header = section.querySelector('.collapsible-section__header');
      const content = section.querySelector('.collapsible-section__content');

      section.classList.add('collapsed');
      header.addEventListener('click', () => {
        const isCollapsed = section.classList.contains('collapsed');
        if (isCollapsed) {
          section.classList.remove('collapsed');
          section.classList.add('expanded');
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          section.classList.add('collapsed');
          section.classList.remove('expanded');
          content.style.maxHeight = '0px';
        }
      });

      // Wire up quantity change listeners
      section.querySelectorAll('.additional-skewer-qty-select').forEach(select => {
        select.addEventListener('change', () => {
          let total = 0;
          section.querySelectorAll('.additional-skewer-qty-select').forEach(s => {
            total += parseInt(s.value) || 0;
          });
          const countEl = section.querySelector('.additional-skewer-count');
          if (countEl) countEl.textContent = total;
          updateOverallUpcharge();
        });
      });

      // Pre-populate from edit session if available
      if (window.packageEditSession && window.packageEditSession.properties &&
          window.packageEditSession.properties['Add On - Additional Skewers']) {
        const propValue = window.packageEditSession.properties['Add On - Additional Skewers'];
        propValue.split(', ').forEach(selection => {
          const match = selection.match(/^(.+?)\s*\((\d+)\)$/);
          if (match) {
            const cleanName = match[1].trim();
            const qty = parseInt(match[2]);
            section.querySelectorAll('.additional-skewer-qty-select').forEach(select => {
              const optionClean = select.dataset.optionName.replace(/\s+Skewers?$/i, '');
              if (optionClean === cleanName) {
                select.value = qty;
                select.dispatchEvent(new Event('change'));
              }
            });
          }
        });
        // Expand the section so pre-filled values are visible
        section.classList.remove('collapsed');
        section.classList.add('expanded');
        content.style.maxHeight = content.scrollHeight + 'px';
      }

    } catch (error) {
      console.error('Error loading additional skewers add-on:', error);
    }
  }

  // Helper function for tapas data (reusable)
  function getTapasItemData(name) {
    const nameLower = name.toLowerCase();
    let color = "#DDD";
    let shape = "🔵";

    if (nameLower.includes("hummus")) {
      color = "#D4B896";
      shape = "🟤";
    } else if (nameLower.includes("baba")) {
      color = "#9B6B9E";
      shape = "🟣";
    } else if (nameLower.includes("dolma")) {
      color = "#7CB342";
      shape = "🟢";
    } else if (nameLower.includes("labne")) {
      color = "#F5F5DC";
      shape = "⚪";
    } else if (nameLower.includes("tzatziki")) {
      color = "#F5F5F5";
      shape = "⚪◌";
    } else if (nameLower.includes("walnut") || nameLower.includes("pepper")) {
      color = "#C85A54";
      shape = "🟤";
    } else if (nameLower.includes("olive") || nameLower.includes("tapenade")) {
      color = "#424242";
      shape = "⚫";
    } else if (nameLower.includes("beet") || nameLower.includes("skordalia")) {
      color = "#E57373";
      shape = "🔴";
    } else if (nameLower.includes("squash") || nameLower.includes("butternut")) {
      color = "#FFB74D";
      shape = "🟠";
    }

    return { name: name, color: color, shape: shape };
  }

  function buildChoiceField(choiceNum, label, type, max, options, upcharges) {
    // Default to 'select' if type is not provided
    type = type || 'select';

    let fieldHTML = `<div class="package-form__field" data-field-type="${type}" data-field-label="${label}">`;

    // Add label for all types except tapas-platter (it has its own header)
    if (type !== 'tapas-platter') {
      fieldHTML += `<label>${label}</label>`;
    }

    if (type === 'tapas-platter') {
      const tapasOptions = options ? options.split(',').map(o => o.trim()) : [];
      const halfPoint = Math.ceil(tapasOptions.length / 2);
      const leftOptions = tapasOptions.slice(0, halfPoint);
      const rightOptions = tapasOptions.slice(halfPoint);

      // Determine if plural (more than 6 selections)
      const headerText = max > 6 ? 'Create Your Tapas Samplers' : 'Create Your Tapas Sampler';

      fieldHTML += `
        <div class="collapsible-section" data-section-type="tapas" data-choice-num="${choiceNum}">
          <div class="collapsible-section__header">
            <h3 class="collapsible-section__title">${headerText}</h3>
            <div class="collapsible-section__icons">
              <svg class="collapsible-section__checkmark" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" fill="#28a745"/>
                <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="collapsible-section__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="collapsible-section__content">
            <div class="tapas-inline-selector" data-max-selections="${max}" data-choice-num="${choiceNum}">
              <h4 class="tapas-inline-selector__header">Choose Any ${max} Tapas</h4>
          <div class="tapas-inline-selector__layout">
            <div class="tapas-inline-selector__column tapas-inline-selector__column--left">`;

      leftOptions.forEach(function(option) {
        const tapasData = getTapasItemData(option);
        fieldHTML += `
              <div class="tapas-inline-item" draggable="true" data-tapas="${option}" data-color="${tapasData.color}" data-shape="${tapasData.shape}">
                <div class="tapas-inline-icon" style="background-color: ${tapasData.color};">
                  <span class="tapas-inline-shape">${tapasData.shape}</span>
                </div>
                <span class="tapas-inline-name">${option}</span>
              </div>`;
      });

      fieldHTML += `
            </div>
            <div class="tapas-inline-selector__column tapas-inline-selector__column--center">
              <div class="tapas-inline-platter">
                <div class="tapas-inline-platter-slots"></div>
              </div>
              <p class="tapas-inline-status" aria-live="polite">Select ${max} tapas</p>
              <a href="#" class="tapas-inline-clear" style="display:none;">remove all</a>
            </div>
            <div class="tapas-inline-selector__column tapas-inline-selector__column--right">`;

      rightOptions.forEach(function(option) {
        const tapasData = getTapasItemData(option);
        fieldHTML += `
              <div class="tapas-inline-item" draggable="true" data-tapas="${option}" data-color="${tapasData.color}" data-shape="${tapasData.shape}">
                <div class="tapas-inline-icon" style="background-color: ${tapasData.color};">
                  <span class="tapas-inline-shape">${tapasData.shape}</span>
                </div>
                <span class="tapas-inline-name">${option}</span>
              </div>`;
      });

      fieldHTML += `
            </div>
          </div>
          <input type="hidden" name="choice_${choiceNum}_tapas_selections" class="tapas-selections-input">
        </div>
          </div>
        </div>`;
    } else if (type === 'sandwich-builder') {
      const sandwichOptions = options.split(',').map(o => o.trim());
      fieldHTML += `
        <div class="collapsible-section" data-section-type="sandwich" data-choice-num="${choiceNum}">
          <div class="collapsible-section__header">
            <h3 class="collapsible-section__title">${label}</h3>
            <div class="collapsible-section__icons">
              <svg class="collapsible-section__checkmark" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" fill="#28a745"/>
                <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="collapsible-section__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="collapsible-section__content">
            <div class="sandwich-builder" data-max-total="${max}" role="group" aria-label="${label}">
              <div class="sandwich-rows">
            <div class="sandwich-row">
              <div class="sandwich-qty">
                <label for="choice-${choiceNum}-sandwich-qty-1">Quantity</label>
                <select id="choice-${choiceNum}-sandwich-qty-1" name="choice_${choiceNum}_sandwich_qty_1" class="sandwich-qty-select" data-row="1" aria-label="Sandwich quantity">
                  <option value="">-</option>`;
      for (let i = 1; i <= 20; i++) {
        fieldHTML += `<option value="${i}">${i}</option>`;
      }
      fieldHTML += `
                </select>
              </div>
              <div class="sandwich-type">
                <label for="choice-${choiceNum}-sandwich-type-1">Sandwich Type</label>
                <select id="choice-${choiceNum}-sandwich-type-1" name="choice_${choiceNum}_sandwich_type_1" class="sandwich-type-select" data-row="1" disabled aria-label="Sandwich type">
                  <option value="">Select...</option>`;
      sandwichOptions.forEach(option => {
        fieldHTML += `<option value="${option}">${option}</option>`;
      });
      fieldHTML += `
                </select>
              </div>
            </div>
              </div>
              <button type="button" class="add-sandwich-row" data-block-id="${currentPackageData.packageId}" aria-label="Add another sandwich selection">+ Add Another Sandwich Selection</button>
              <p class="sandwich-total" aria-live="polite">Total Sandwiches: <span>0</span>/${max}</p>
            </div>
          </div>
        </div>`;
    } else if (type === 'select') {
      const selectOptions = options ? options.split(',').map(o => o.trim()) : [];
      fieldHTML += `
        <select id="choice-${choiceNum}-${currentPackageData.packageId}" name="choice_${choiceNum}" required aria-label="${label}" aria-required="true">
          <option value="">Select...</option>`;
      selectOptions.forEach(option => {
        fieldHTML += `<option value="${option}">${option}</option>`;
      });
      fieldHTML += `</select>`;
    } else if (type === 'multiselect') {
      const selectOptions = options ? options.split(',').map(o => o.trim()) : [];
      fieldHTML += `
        <div class="checkbox-group" data-max-selections="${max}" role="group" aria-label="${label}">`;
      selectOptions.forEach((option, idx) => {
        const optionId = `choice-${choiceNum}-option-${idx}`;
        fieldHTML += `
          <label class="checkbox-option">
            <input type="checkbox" id="${optionId}" name="choice_${choiceNum}[]" value="${option}" aria-label="${option}">
            <span>${option}</span>
          </label>`;
      });
      fieldHTML += `</div>`;
    } else if (type === 'dropdown-sequence') {
      const selectOptions = options ? options.split(',').map(o => o.trim()) : [];
      const numberWords = ["One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve"];
      // Derive a singular noun from the label (e.g. "Choose 2 Salads (Half Tray)" -> "Salad")
      const itemPrefixMatch = label.match(/Choose\s+\d+\s+(.+?)(?:\s*\(|$)/i);
      const rawNoun = itemPrefixMatch ? itemPrefixMatch[1].trim() : 'Option';
      // Singularize: strip trailing 's' unless preceded by 'a' or 's' (e.g. "Tapas" stays, "Salads" -> "Salad")
      const itemPrefix = rawNoun.replace(/(?<![as])s$/, '');
      fieldHTML += `<div class="dropdown-sequence" role="group" aria-label="${label}">`;
      for (let i = 1; i <= max; i++) {
        const selectId = `choice-${choiceNum}-item-${i}`;
        const selectLabel = `${itemPrefix} ${numberWords[i-1]}`;
        fieldHTML += `
          <div class="dropdown-item">
            <label for="${selectId}">${selectLabel}</label>
            <select id="${selectId}" name="choice_${choiceNum}_item_${i}" required aria-label="${selectLabel}" aria-required="true">
              <option value="">Select...</option>`;
        selectOptions.forEach(option => {
          fieldHTML += `<option value="${option}">${option}</option>`;
        });
        fieldHTML += `
            </select>
          </div>`;
      }
      fieldHTML += `</div>`;
    } else if (type === 'quantity') {
      const selectOptions = options ? options.split(',').map(o => o.trim()) : [];
      fieldHTML += `
        <div class="quantity-group" data-max-total="${max}" role="group" aria-label="${label}">`;
      selectOptions.forEach(option => {
        const handleized = option.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        const inputId = `choice-${choiceNum}-qty-${handleized}`;
        fieldHTML += `
          <div class="quantity-option">
            <label for="${inputId}">${option}</label>
            <input type="number" id="${inputId}" name="choice_${choiceNum}_qty_${handleized}" value="0" min="0" max="${max}" data-option-name="${option}" aria-label="Quantity of ${option}">
          </div>`;
      });
      fieldHTML += `
          <p class="quantity-total" aria-live="polite">Total: <span>0</span>/${max}</p>
        </div>`;
    } else if (type === 'skewer-builder') {
      const selectOptions = options ? options.split(',').map(o => o.trim()) : [];
      const upchargeValues = upcharges ? upcharges.split(',').map(u => parseFloat(u.trim()) || 0) : [];

      fieldHTML += `
        <div class="collapsible-section" data-section-type="skewer" data-choice-num="${choiceNum}">
          <div class="collapsible-section__header">
            <h3 class="collapsible-section__title">${label}</h3>
            <div class="collapsible-section__icons">
              <svg class="collapsible-section__checkmark" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" fill="#28a745"/>
                <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="collapsible-section__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="collapsible-section__content">
            <div class="skewer-builder" data-max-total="${max}" data-choice-num="${choiceNum}" role="group" aria-label="${label}">
              <div class="skewer-builder__grid">`;

      selectOptions.forEach((option, index) => {
        const handleized = option.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        const upcharge = upchargeValues[index] || 0;
        // Remove "Skewers" from the label
        const cleanLabel = option.replace(/\s+Skewers?$/i, '');
        const selectId = `choice-${choiceNum}-skewer-${handleized}`;

        // Add label with optional upcharge on second line
        if (upcharge > 0) {
          fieldHTML += `<label for="${selectId}">${cleanLabel}<br><small>+$${upcharge} / each</small></label>`;
        } else {
          fieldHTML += `<label for="${selectId}">${cleanLabel}</label>`;
        }

        // Add dropdown
        fieldHTML += `
            <select id="${selectId}"
              name="choice_${choiceNum}_skewer_qty_${handleized}"
              class="skewer-qty-select"
              data-option-name="${option}"
              data-upcharge="${upcharge}"
              aria-label="Quantity of ${option}">
              <option value="0">0</option>`;

        for (let i = 1; i <= max; i++) {
          fieldHTML += `<option value="${i}">${i}</option>`;
        }

        fieldHTML += `</select>`;

        // Add spacer after first item in each pair (index 0, 2, 4...) except the last
        if (index % 2 === 0 && index < selectOptions.length - 1) {
          fieldHTML += `<div class="skewer-spacer"></div>`;
        }
      });

      fieldHTML += `
          </div>
          <p class="skewer-builder__status"><span class="skewer-count">0</span>/${max} skewers selected</p>
        </div>
          </div>
        </div>`;
    }

    fieldHTML += `</div>`;
    return fieldHTML;
  }

  function initializeOverlayFormHandlers() {
    // Quantity selector in footer
    const overlayQuantitySelector = packageOrderFooter.querySelector('.overlay-quantity-selector');
    if (overlayQuantitySelector) {
      const select = overlayQuantitySelector.querySelector('#overlay-quantity');
      const pluralSpan = overlayQuantitySelector.querySelector('#package-plural');

      select.addEventListener('change', function() {
        const quantity = parseInt(select.value);
        pluralSpan.textContent = quantity === 1 ? 'package' : 'packages';
        updateOverallUpcharge();
      });
    }

    // Initialize inline tapas selectors
    packageOrderBody.querySelectorAll('.tapas-inline-selector').forEach(function(selector) {
      initializeInlineTapasSelector(selector);
    });

    // Sandwich builder in overlay
    const sandwichBuilders = packageOrderBody.querySelectorAll('.sandwich-builder');
    sandwichBuilders.forEach(function(builder) {
      updateSandwichBuilder(builder);
      attachSandwichRowListeners(builder);
    });

    packageOrderBody.querySelectorAll('.add-sandwich-row').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const builder = btn.closest('.sandwich-builder');
        const rowsContainer = builder.querySelector('.sandwich-rows');
        const rowNum = rowsContainer.querySelectorAll('.sandwich-row').length + 1;

        const firstRow = rowsContainer.querySelector('.sandwich-row');
        const newRow = firstRow.cloneNode(true);

        newRow.querySelectorAll('select').forEach(select => {
          const baseName = select.name.replace(/_\d+$/, '');
          select.name = baseName + '_' + rowNum;
          select.dataset.row = rowNum;
          select.value = '';
          if (select.classList.contains('sandwich-type-select')) {
            select.disabled = true;
          }
        });

        rowsContainer.appendChild(newRow);
        attachSandwichRowListeners(builder);
      });
    });

    // Checkbox groups in overlay
    packageOrderBody.querySelectorAll('.checkbox-group').forEach(function(group) {
      const maxSelections = parseInt(group.dataset.maxSelections);
      const checkboxes = group.querySelectorAll('input[type="checkbox"]');

      function updateCheckboxes() {
        const checked = group.querySelectorAll('input[type="checkbox"]:checked');

        if (checked.length >= maxSelections) {
          checkboxes.forEach(cb => {
            if (!cb.checked) cb.disabled = true;
          });
        } else {
          checkboxes.forEach(cb => cb.disabled = false);
        }
      }

      checkboxes.forEach(cb => cb.addEventListener('change', updateCheckboxes));
    });

    // Quantity groups in overlay
    packageOrderBody.querySelectorAll('.quantity-group').forEach(function(group) {
      const maxTotal = parseInt(group.dataset.maxTotal);
      const inputs = group.querySelectorAll('input[type="number"]');
      const totalDisplay = group.querySelector('.quantity-total span');

      function updateTotal() {
        let total = 0;
        inputs.forEach(input => {
          total += parseInt(input.value) || 0;
        });
        totalDisplay.textContent = total;

        // Disable inputs if total reached
        if (total >= maxTotal) {
          inputs.forEach(input => {
            if (parseInt(input.value) === 0) {
              input.disabled = true;
            }
          });
        } else {
          inputs.forEach(input => input.disabled = false);
        }

        // Update max values dynamically
        inputs.forEach(input => {
          const currentVal = parseInt(input.value) || 0;
          input.max = maxTotal - total + currentVal;
        });
      }

      inputs.forEach(input => {
        input.addEventListener('input', updateTotal);
        input.addEventListener('change', updateTotal);
      });
    });

    // Skewer builder in overlay
    packageOrderBody.querySelectorAll('.skewer-builder').forEach(function(builder) {
      updateSkewerBuilder(builder);
      attachSkewerBuilderListeners(builder);
    });

    // Add to Cart button
    const addToCartBtn = document.getElementById('overlay-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', handleOverlayAddToCart);
    }

    // Initialize collapsible sections
    initCollapsibleSections();
  }

  function initCollapsibleSections() {
    const sections = packageOrderBody.querySelectorAll('.collapsible-section');

    sections.forEach(section => {
      const header = section.querySelector('.collapsible-section__header');
      const content = section.querySelector('.collapsible-section__content');
      const icon = section.querySelector('.collapsible-section__icon');
      const sectionType = section.dataset.sectionType;
      const choiceNum = section.dataset.choiceNum;

      // Start collapsed
      section.classList.add('collapsed');
      content.style.maxHeight = '0px';

      // Header click handler
      header.addEventListener('click', () => {
        const isCollapsed = section.classList.contains('collapsed');

        if (isCollapsed) {
          // Expand
          section.classList.remove('collapsed');
          section.classList.add('expanded');
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          // Collapse
          section.classList.add('collapsed');
          section.classList.remove('expanded');
          content.style.maxHeight = '0px';
        }
      });

      // Auto-collapse when selections are complete
      if (sectionType === 'tapas') {
        const tapasSelector = content.querySelector('.tapas-inline-selector');
        if (tapasSelector) {
          const maxSelections = parseInt(tapasSelector.dataset.maxSelections);

          // Watch for completion
          const observer = new MutationObserver(() => {
            const slots = tapasSelector.querySelectorAll('.tapas-inline-platter-slot');
            if (slots.length === maxSelections) {
              // Mark as completed
              section.classList.add('completed');

              if (!section.classList.contains('collapsed')) {
                // Auto-collapse after 1 second
                setTimeout(() => {
                  if (!section.classList.contains('collapsed')) {
                    section.classList.add('collapsed');
                    section.classList.remove('expanded');
                    content.style.maxHeight = '0px';
                  }
                }, 1000);
              }
            } else {
              section.classList.remove('completed');
            }
          });

          const platterSlots = tapasSelector.querySelector('.tapas-inline-platter-slots');
          if (platterSlots) {
            observer.observe(platterSlots, { childList: true, subtree: true });
          }
        }
      } else if (sectionType === 'skewer') {
        const skewerBuilder = content.querySelector('.skewer-builder');
        if (skewerBuilder) {
          const maxTotal = parseInt(skewerBuilder.dataset.maxTotal);
          const selects = skewerBuilder.querySelectorAll('.skewer-qty-select');

          const checkCompletion = () => {
            let total = 0;
            selects.forEach(select => {
              total += parseInt(select.value) || 0;
            });

            if (total === maxTotal) {
              // Mark as completed
              section.classList.add('completed');

              if (!section.classList.contains('collapsed')) {
                // Auto-collapse after 1 second
                setTimeout(() => {
                  if (!section.classList.contains('collapsed')) {
                    section.classList.add('collapsed');
                    section.classList.remove('expanded');
                    content.style.maxHeight = '0px';
                  }
                }, 1000);
              }
            } else {
              section.classList.remove('completed');
            }
          };

          // Initial check
          checkCompletion();

          selects.forEach(select => {
            select.addEventListener('change', checkCompletion);
          });
        }
      } else if (sectionType === 'sandwich') {
        const sandwichBuilder = content.querySelector('.sandwich-builder');
        if (sandwichBuilder) {
          const maxTotal = parseInt(sandwichBuilder.dataset.maxTotal);

          const checkCompletion = () => {
            let total = 0;
            const qtySelects = sandwichBuilder.querySelectorAll('.sandwich-qty-select');
            qtySelects.forEach(select => {
              total += parseInt(select.value) || 0;
            });

            if (total === maxTotal) {
              // Mark as completed
              section.classList.add('completed');

              if (!section.classList.contains('collapsed')) {
                // Auto-collapse after 1 second
                setTimeout(() => {
                  if (!section.classList.contains('collapsed')) {
                    section.classList.add('collapsed');
                    section.classList.remove('expanded');
                    content.style.maxHeight = '0px';
                  }
                }, 1000);
              }
            } else {
              section.classList.remove('completed');
            }
          };

          // Listen for changes on all sandwich selects (initially and when rows are added)
          const attachListeners = () => {
            const qtySelects = sandwichBuilder.querySelectorAll('.sandwich-qty-select');
            qtySelects.forEach(select => {
              select.removeEventListener('change', checkCompletion);
              select.addEventListener('change', checkCompletion);
            });
          };

          attachListeners();

          // Initial check
          checkCompletion();

          // Watch for new sandwich rows being added
          const rowObserver = new MutationObserver(() => {
            attachListeners();
          });

          const rowsContainer = sandwichBuilder.querySelector('.sandwich-rows');
          if (rowsContainer) {
            rowObserver.observe(rowsContainer, { childList: true });
          }
        }
      }
    });
  }

  function updateOverallUpcharge() {
    // No-op in wizard mode until the review step renders the price display
    if (!document.getElementById('total-price-display')) return;
    // Calculate total upcharge from all skewer-builder fields
    let totalUpcharge = 0;
    packageOrderBody.querySelectorAll('.skewer-builder').forEach(function(builder) {
      builder.querySelectorAll('.skewer-qty-select').forEach(input => {
        const qty = parseInt(input.value) || 0;
        const itemUpcharge = parseFloat(input.dataset.upcharge) || 0;
        totalUpcharge += qty * itemUpcharge;
      });
    });

    // Add dessert plate addon to upcharge calculation
    const dessertPlateSelect = document.getElementById('addon-dessert-plate');
    if (dessertPlateSelect) {
      const dessertQty = parseInt(dessertPlateSelect.value) || 0;
      const dessertPrice = parseFloat(dessertPlateSelect.closest('.addon-item')?.dataset.addonPrice) || 0;
      totalUpcharge += dessertQty * dessertPrice;
    }

    // Add additional skewer costs
    packageOrderBody.querySelectorAll('.additional-skewer-qty-select').forEach(select => {
      const qty = parseInt(select.value) || 0;
      const price = parseFloat(select.dataset.price) || 0;
      totalUpcharge += qty * price;
    });

    // Update total price display
    const totalPriceDisplay = packageOrderFooter.querySelector('#total-price-display');
    const upchargeRow = packageOrderFooter.querySelector('#upcharge-row');
    const upchargeValue = packageOrderFooter.querySelector('#upcharge-value');
    const totalPriceValue = packageOrderFooter.querySelector('#total-price-value');
    const quantityInput = packageOrderFooter.querySelector('#overlay-quantity');

    if (totalPriceDisplay && upchargeRow && upchargeValue && totalPriceValue) {
      const quantity = parseInt(quantityInput?.value) || 1;

      // Parse base price (remove $ and any commas)
      const basePriceStr = currentPackageData.packagePrice.replace(/[$,]/g, '');
      const basePrice = parseFloat(basePriceStr) || 0;

      // Calculate total
      const totalWithUpcharge = basePrice + totalUpcharge;
      const finalTotal = totalWithUpcharge * quantity;

      // Show/hide upcharge row
      if (totalUpcharge > 0) {
        upchargeRow.style.display = 'flex';
        upchargeValue.textContent = `+$${totalUpcharge.toFixed(2)}`;
        totalPriceDisplay.style.display = 'block';
        totalPriceValue.textContent = `$${finalTotal.toFixed(2)}`;
      } else {
        upchargeRow.style.display = 'none';
        totalPriceDisplay.style.display = 'none';
      }
    }

    // Store upcharge for cart submission
    const form = document.getElementById('overlay-package-form');
    if (form) {
      form.dataset.upcharge = totalUpcharge;
    }
  }

  async function handleOverlayAddToCart() {
    // If in edit mode, remove old items first
    if (window.packageEditSession) {
      try {
        const cartData = await fetch('/cart.js').then(r => r.json());

        // Remove the package items
        const itemsToRemove = cartData.items.filter(item => item.variant_id === window.packageEditSession.variantId);

        // Also remove any upcharge items associated with this package
        const upchargeItems = cartData.items.filter(item =>
          (item.product_handle === 'premium-skewer-salmon' ||
           item.product_handle === 'premium-skewer-octopus' ||
           item.product_handle === 'additional-skewers') &&
          item.properties &&
          item.properties['_Part of'] === (window.packageEditSession.packageName || 'Party Package')
        );

        for (const item of [...itemsToRemove, ...upchargeItems]) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        }

        window.packageEditSession = null;
        sessionStorage.removeItem('packageEditSession');
      } catch (error) {
        console.error('Error removing old cart items:', error);
        showToast('Error updating cart. Please try again.', 'error');
        return;
      }
    }

    const form = document.getElementById('overlay-package-form');
    const variantId = form.dataset.variantId;
    const quantity = parseInt(document.getElementById('overlay-quantity').value);

    // Build properties from form
    const properties = {};

    // Handle regular selects
    form.querySelectorAll('select').forEach(select => {
      if (select.value && select.name && !select.closest('.sandwich-builder') && !select.closest('.skewer-builder') && !select.closest('.package-form__addons') && !select.closest('.dropdown-sequence') && select.id !== 'addon-dessert-plate' && select.id !== 'overlay-quantity') {
        const label = select.previousElementSibling?.textContent || select.name;
        properties[label] = select.value;
      }
    });

    // Handle tapas selections (inline selector)
    const tapasInputs = form.querySelectorAll('.tapas-selections-input');
    tapasInputs.forEach(input => {
      if (input && input.value) {
        const field = input.closest('.package-form__field');
        const fieldLabel = field.dataset.fieldLabel || field.querySelector('label')?.textContent || 'Tapas Selection';
        properties[fieldLabel.trim()] = input.value;
      }
    });

    // Handle sandwich builder
    form.querySelectorAll('.sandwich-builder').forEach(builder => {
      const rows = builder.querySelectorAll('.sandwich-row');
      const selections = [];
      rows.forEach(row => {
        const qty = row.querySelector('.sandwich-qty-select').value;
        const type = row.querySelector('.sandwich-type-select').value;
        if (qty && type) {
          selections.push(`${type} (${qty})`);
        }
      });
      if (selections.length > 0) {
        const label = builder.closest('.package-form__field').querySelector('label').textContent.trim();
        properties[label] = selections.join(', ');
      }
    });

    // Handle checkbox groups (multiselect)
    form.querySelectorAll('.checkbox-group').forEach(group => {
      const checked = Array.from(group.querySelectorAll('input[type="checkbox"]:checked'));
      if (checked.length > 0) {
        const label = group.closest('.package-form__field').querySelector('label').textContent.trim();
        properties[label] = checked.map(cb => cb.value).join(', ');
      }
    });

    // Handle quantity groups
    form.querySelectorAll('.quantity-group').forEach(group => {
      const inputs = group.querySelectorAll('input[type="number"]');
      const selections = [];
      inputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        if (qty > 0) {
          const optionName = input.dataset.optionName;
          selections.push(`${optionName} (${qty})`);
        }
      });
      if (selections.length > 0) {
        const label = group.closest('.package-form__field').querySelector('label').textContent.trim();
        properties[label] = selections.join(', ');
      }
    });

    // Handle skewer builder
    form.querySelectorAll('.skewer-builder').forEach(builder => {
      const inputs = builder.querySelectorAll('.skewer-qty-select');
      const selections = [];
      let builderUpcharge = 0;

      inputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        if (qty > 0) {
          const optionName = input.dataset.optionName;
          const itemUpcharge = parseFloat(input.dataset.upcharge) || 0;
          selections.push(`${optionName} (${qty})`);
          builderUpcharge += qty * itemUpcharge;
        }
      });

      if (selections.length > 0) {
        const label = builder.closest('.package-form__field').querySelector('label').textContent.trim();
        properties[label] = selections.join(', ');
        // Don't save upcharge as a property - it's added as a separate line item
        // if (builderUpcharge > 0) {
        //   properties[label + ' Upcharge'] = `$${builderUpcharge.toFixed(2)}`;
        // }
      }
    });

    // Handle dropdown-sequence (individual tapas dropdowns)
    form.querySelectorAll('.dropdown-sequence').forEach(group => {
      const selects = group.querySelectorAll('select');
      const selections = [];
      selects.forEach(select => {
        if (select.value) {
          const label = select.previousElementSibling?.textContent || `Item ${selections.length + 1}`;
          selections.push(`${label}: ${select.value}`);
        }
      });
      if (selections.length > 0) {
        const label = group.closest('.package-form__field').querySelector('label').textContent.trim();
        properties[label] = selections.join(', ');
      }
    });

    // Validate
    let isValid = true;

    // Check tapas selections (inline selector)
    const tapasSelectors = form.querySelectorAll('.tapas-inline-selector');
    tapasSelectors.forEach(selector => {
      const maxSelections = parseInt(selector.dataset.maxSelections);
      const hiddenInput = selector.querySelector('.tapas-selections-input');

      // Count actual tapas (parse quantities like "Hummus (2)")
      let totalCount = 0;
      if (hiddenInput.value) {
        const items = hiddenInput.value.split(', ');
        items.forEach(item => {
          const match = item.match(/\((\d+)\)$/);
          if (match) {
            totalCount += parseInt(match[1]);
          } else {
            totalCount += 1;
          }
        });
      }

      if (totalCount !== maxSelections) {
        showToast(`Please select exactly ${maxSelections} tapas. Currently selected: ${totalCount}`, 'warning');
        isValid = false;
      }
    });

    // Check sandwich builder totals
    form.querySelectorAll('.sandwich-builder').forEach(builder => {
      const maxTotal = parseInt(builder.dataset.maxTotal);
      const qtySelects = builder.querySelectorAll('.sandwich-qty-select');
      let total = 0;
      let hasIncomplete = false;

      qtySelects.forEach(qtySelect => {
        const row = qtySelect.closest('.sandwich-row');
        const typeSelect = row.querySelector('.sandwich-type-select');
        const qty = parseInt(qtySelect.value) || 0;

        if (qty > 0 && !typeSelect.value) {
          hasIncomplete = true;
        }
        total += qty;
      });

      if (total !== maxTotal) {
        showToast(`Sandwiches must total exactly ${maxTotal}. Current total: ${total}`, 'warning');
        isValid = false;
      }

      if (hasIncomplete) {
        showToast('Please select sandwich type for all quantities', 'warning');
        isValid = false;
      }
    });

    // Check multiselect fields have correct number of selections
    form.querySelectorAll('.checkbox-group').forEach(group => {
      const maxSelections = parseInt(group.dataset.maxSelections);
      const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
      if (maxSelections && checked !== maxSelections) {
        showToast(`Please select exactly ${maxSelections} options`, 'warning');
        isValid = false;
      }
    });

    // Check quantity fields sum to max
    form.querySelectorAll('.quantity-group').forEach(group => {
      const maxTotal = parseInt(group.dataset.maxTotal);
      let total = 0;
      group.querySelectorAll('input[type="number"]').forEach(input => {
        total += parseInt(input.value) || 0;
      });
      if (total !== maxTotal) {
        showToast(`Please select exactly ${maxTotal} total items`, 'warning');
        isValid = false;
      }
    });

    // Check skewer builder totals
    form.querySelectorAll('.skewer-builder').forEach(builder => {
      const maxTotal = parseInt(builder.dataset.maxTotal);
      let total = 0;
      builder.querySelectorAll('.skewer-qty-select').forEach(select => {
        total += parseInt(select.value) || 0;
      });
      if (total === 0) {
        showToast('Please select at least one skewer', 'warning');
        isValid = false;
      } else if (total > maxTotal) {
        showToast(`Skewers cannot exceed ${maxTotal}. Current total: ${total}`, 'warning');
        isValid = false;
      }
    });

    // Check dropdown-sequence (all required)
    form.querySelectorAll('.dropdown-sequence select[required]').forEach(select => {
      if (!select.value) {
        showToast('Please select all options', 'warning');
        isValid = false;
      }
    });

    // Check required dropdowns
    form.querySelectorAll('select[required]').forEach(select => {
      if (!select.value && !select.closest('.sandwich-builder') && !select.closest('.dropdown-sequence')) {
        showToast('Please complete all required fields', 'warning');
        isValid = false;
      }
    });

    if (!isValid) return;

    // Calculate total upcharge
    const totalUpcharge = parseFloat(form.dataset.upcharge) || 0;
    if (totalUpcharge > 0) {
      properties['_Upcharge Amount'] = `$${totalUpcharge.toFixed(2)}`;
      properties['_Note'] = `Add $${totalUpcharge.toFixed(2)} upcharge to base price`;
    }

    // Add dessert plate addon to properties
    const dessertPlateSelect = document.getElementById('addon-dessert-plate');
    const dessertPlateQty = dessertPlateSelect ? parseInt(dessertPlateSelect.value) || 0 : 0;
    if (dessertPlateQty > 0) {
      properties['Add On - Mixed Dessert Plate'] = `${dessertPlateQty} plate${dessertPlateQty > 1 ? 's' : ''}`;
    }

    // Collect additional skewer selections
    const additionalSkewers = [];
    packageOrderBody.querySelectorAll('.additional-skewer-qty-select').forEach(select => {
      const qty = parseInt(select.value) || 0;
      if (qty > 0) {
        additionalSkewers.push({
          variantId: parseInt(select.dataset.variantId),
          qty,
          optionName: select.dataset.optionName
        });
      }
    });
    if (additionalSkewers.length > 0) {
      properties['Add On - Additional Skewers'] = additionalSkewers
        .map(s => `${s.optionName.replace(/\s+Skewers?$/i, '')} (${s.qty})`)
        .join(', ');
    }

    // Add to cart
    const button = document.getElementById('overlay-add-to-cart');
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties
        })
      });

      if (response.ok) {
        await response.json();

        // Calculate individual skewer upcharges (Salmon $6, Octopus $7)
        let salmonQty = 0;
        let octopusQty = 0;

        form.querySelectorAll('.skewer-builder').forEach(builder => {
          builder.querySelectorAll('.skewer-qty-select').forEach(input => {
            const qty = parseInt(input.value) || 0;
            const optionName = input.dataset.optionName;

            if (optionName === 'Salmon Skewers') {
              salmonQty += qty;
            } else if (optionName === 'Octopus Skewers') {
              octopusQty += qty;
            }
          });
        });

        // Add salmon upcharge if any salmon skewers selected
        if (salmonQty > 0) {
          try {
            const salmonUpchargeResponse = await fetch('/products/premium-skewer-salmon.js');
            if (salmonUpchargeResponse.ok) {
              const salmonProduct = await salmonUpchargeResponse.json();
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: salmonProduct.variants[0].id,
                  quantity: salmonQty,
                  properties: {
                    '_Part of': currentPackageData.packageName || 'Party Package',
                    '_Hidden': 'true'
                  }
                })
              });
            } else {
              console.warn('Salmon upcharge product not found. Please create a product with handle "premium-skewer-salmon" priced at $6.00');
            }
          } catch (error) {
            console.error('Error adding salmon upcharge:', error);
          }
        }

        // Add octopus upcharge if any octopus skewers selected
        if (octopusQty > 0) {
          try {
            const octopusUpchargeResponse = await fetch('/products/premium-skewer-octopus.js');
            if (octopusUpchargeResponse.ok) {
              const octopusProduct = await octopusUpchargeResponse.json();
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: octopusProduct.variants[0].id,
                  quantity: octopusQty,
                  properties: {
                    '_Part of': currentPackageData.packageName || 'Party Package',
                    '_Hidden': 'true'
                  }
                })
              });
            } else {
              console.warn('Octopus upcharge product not found. Please create a product with handle "premium-skewer-octopus" priced at $7.00');
            }
          } catch (error) {
            console.error('Error adding octopus upcharge:', error);
          }
        }

        // Add dessert plate addon if selected
        if (dessertPlateQty > 0) {
          try {
            const dessertPlateResponse = await fetch('/products/mixed-dessert-plate.js');
            if (dessertPlateResponse.ok) {
              const dessertPlateProduct = await dessertPlateResponse.json();
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: dessertPlateProduct.variants[0].id,
                  quantity: dessertPlateQty,
                  properties: {
                    '_Part of': currentPackageData.packageName || 'Party Package',
                    '_Hidden': 'true'
                  }
                })
              });
            } else {
              console.warn('Mixed Dessert Plate product not found. Please create a product with handle "mixed-dessert-plate"');
            }
          } catch (error) {
            console.error('Error adding dessert plate addon:', error);
          }
        }

        // Add additional skewer line items (visible in cart)
        for (const skewer of additionalSkewers) {
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: skewer.variantId,
                quantity: skewer.qty,
                properties: {
                  '_Part of': currentPackageData.packageName || 'Party Package'
                }
              })
            });
          } catch (error) {
            console.error('Error adding additional skewer to cart:', error);
          }
        }

        // Clear edit session after successful add to cart
        window.packageEditSession = null;
        sessionStorage.removeItem('packageEditSession');

        // Close overlay first
        closePackageOrderOverlay();

        // Wait for overlay to close, then refresh and open cart
        setTimeout(async () => {
          // Use global CartManager to refresh and open cart
          const cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer && window.cartManagerInstance) {
            await window.cartManagerInstance.refreshCart(true);
            window.cartManagerInstance.openCart();
          } else {
            // Fallback: Try clicking the cart icon
            const cartIcon = document.querySelector('[data-cart-toggle]');
            if (cartIcon) {
              cartIcon.click();
            } else {
              // Fallback: navigate to cart page
              window.location.href = '/cart';
            }
          }
        }, 300);
      } else {
        console.error('Failed to add to cart');
        showToast('Failed to add to cart. Please try again.', 'error');
        button.textContent = 'Error - Try Again';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showToast('An error occurred. Please try again.', 'error');
      button.textContent = 'Error - Try Again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  // Initialize inline tapas selector
  function initializeInlineTapasSelector(selector) {
    const maxSelections = parseInt(selector.dataset.maxSelections);
    const platterSlots = selector.querySelector('.tapas-inline-platter-slots');
    const statusDisplay = selector.querySelector('.tapas-inline-status');
    const clearLink = selector.querySelector('.tapas-inline-clear');
    const hiddenInput = selector.querySelector('.tapas-selections-input');
    const tapasItems = selector.querySelectorAll('.tapas-inline-item');

    let selectedItems = [];

    // Check for preselected items (from edit mode)
    if (selector.dataset.preselected) {
      try {
        selectedItems = JSON.parse(selector.dataset.preselected);
        delete selector.dataset.preselected;
      } catch (e) {
        console.error('Error parsing preselected tapas:', e);
      }
    }

    // Listen for preload event
    selector.addEventListener('tapas-preload', function() {
      if (selector.dataset.preselected) {
        try {
          const preselectedData = JSON.parse(selector.dataset.preselected);
          selectedItems.length = 0; // Clear existing
          selectedItems.push(...preselectedData); // Add preselected
          delete selector.dataset.preselected;
          updatePlatter();
        } catch (e) {
          console.error('Error parsing preselected tapas:', e);
        }
      }
    });
    let draggedElement = null;

    // Item click handlers
    tapasItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        if (selectedItems.length < maxSelections) {
          addToPlatter(item);
        }
      });

      // Desktop drag events
      item.addEventListener('dragstart', function(e) {
        draggedElement = this;
        this.classList.add('dragging');
        e.dataTransfer.effectAllowed = 'copy';
      });

      item.addEventListener('dragend', function() {
        this.classList.remove('dragging');
        draggedElement = null;
      });
    });

    // Platter drop zone
    const platter = selector.querySelector('.tapas-inline-platter');
    platter.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      this.classList.add('drag-over');
    });

    platter.addEventListener('dragleave', function() {
      this.classList.remove('drag-over');
    });

    platter.addEventListener('drop', function(e) {
      e.preventDefault();
      this.classList.remove('drag-over');

      if (draggedElement && selectedItems.length < maxSelections) {
        addToPlatter(draggedElement);
      }
    });

    // Clear link
    clearLink.addEventListener('click', function(e) {
      e.preventDefault();
      selectedItems = [];
      updatePlatter();
    });

    function addToPlatter(item) {
      const tapasName = item.dataset.tapas;

      if (selectedItems.length >= maxSelections) {
        return;
      }

      selectedItems.push({
        name: tapasName,
        color: item.dataset.color,
        shape: item.dataset.shape
      });

      updatePlatter();
    }

    function removeFromPlatter(index) {
      selectedItems.splice(index, 1);
      updatePlatter();
    }

    function updatePlatter() {
      // Update status message
      const remaining = maxSelections - selectedItems.length;
      if (remaining === 0) {
        statusDisplay.textContent = '✓ Complete!';
        statusDisplay.style.color = '#2E7D32';
      } else {
        statusDisplay.textContent = `Click or drag ${remaining} more to add`;
        statusDisplay.style.color = '#8B1E1E';
      }

      // Show/hide clear link
      clearLink.style.display = selectedItems.length > 0 ? 'inline' : 'none';

      // Group items by name and count
      const itemGroups = {};
      selectedItems.forEach(function(item, index) {
        if (!itemGroups[item.name]) {
          itemGroups[item.name] = {
            name: item.name,
            color: item.color,
            shape: item.shape,
            count: 0,
            indices: []
          };
        }
        itemGroups[item.name].count++;
        itemGroups[item.name].indices.push(index);
      });

      const uniqueItems = Object.values(itemGroups);

      // Update hidden input with grouped counts
      const tapasStrings = uniqueItems.map(group => {
        return group.count > 1 ? `${group.name} (${group.count})` : group.name;
      });
      hiddenInput.value = tapasStrings.join(', ');

      // Render items on platter
      platterSlots.innerHTML = '';
      uniqueItems.forEach(function(group, displayIndex) {
        const slot = document.createElement('div');
        slot.className = 'tapas-inline-platter-slot';
        const quantityBadge = group.count > 1 ? `<span class="tapas-inline-quantity-badge">×${group.count}</span>` : '';

        slot.innerHTML = `
          <div class="tapas-inline-platter-item" style="background-color: ${group.color};" data-group-name="${group.name}">
            <span class="tapas-inline-platter-shape">${group.shape}</span>
            ${quantityBadge}
            <button type="button" class="tapas-inline-remove-btn" data-group-name="${group.name}" aria-label="Remove ${group.name}">×</button>
            <span class="tapas-inline-platter-name">${group.name}</span>
          </div>
        `;
        platterSlots.appendChild(slot);

        // Position at specific platter compartment locations
        // Platter compartments are at clock positions: 6:00, 8:25, 11:25, 1:50, 4:10, and center
        // Each compartment can hold 2 items stacked
        const compartmentPositions = [
          { x: 0, y: 55 },      // 6:00 (bottom)
          { x: -51, y: 21 },    // 8:25 (lower left)
          { x: -35, y: -35 },   // 11:25 (upper left)
          { x: 35, y: -35 },    // 1:50 (upper right)
          { x: 51, y: 21 },     // 4:10 (lower right)
          { x: 0, y: 0 }        // Center
        ];

        const compartmentIndex = displayIndex % 6;
        const itemLayer = Math.floor(displayIndex / 6);
        const basePos = compartmentPositions[compartmentIndex] || { x: 0, y: 0 };

        // Offset second item slightly (overlap effect)
        const offset = itemLayer * 8;
        const pos = { x: basePos.x + offset, y: basePos.y + offset };

        slot.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
        if (itemLayer > 0) {
          slot.style.zIndex = itemLayer;
        }
      });

      // Attach remove handlers
      platterSlots.querySelectorAll('.tapas-inline-remove-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          const groupName = this.dataset.groupName;
          const index = selectedItems.findIndex(item => item.name === groupName);
          if (index !== -1) {
            removeFromPlatter(index);
          }
        });
      });

      // Grey out items if max reached
      tapasItems.forEach(function(item) {
        if (selectedItems.length >= maxSelections) {
          item.classList.add('disabled');
        } else {
          item.classList.remove('disabled');
        }
      });
    }

    updatePlatter();
  }

  function closePackageOrderOverlay() {
    packageOrderOverlay.style.display = 'none';
    packageOrderOverlay.removeAttribute('aria-modal');
    document.body.style.overflow = '';
    packageOrderBody.innerHTML = '';
    packageOrderFooter.innerHTML = '';
    currentPackageData = null;
    currentWizardStep = 0;
    wizardNavigating = false;

    // Clear edit session when modal closes (in case user cancels edit)
    if (window.packageEditSession) {
      window.packageEditSession = null;
      sessionStorage.removeItem('packageEditSession');
    }
  }

  packageOrderClose.addEventListener('click', closePackageOrderOverlay);
  packageOrderBackdrop.addEventListener('click', closePackageOrderOverlay);

  // Quantity selector
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    const input = selector.querySelector('input[type="number"]');
    const minusBtn = selector.querySelector('[data-action="minus"]');
    const plusBtn = selector.querySelector('[data-action="plus"]');

    minusBtn.addEventListener('click', function() {
      const currentValue = parseInt(input.value);
      if (currentValue > parseInt(input.min)) {
        input.value = currentValue - 1;
      }
    });

    plusBtn.addEventListener('click', function() {
      const currentValue = parseInt(input.value);
      if (currentValue < parseInt(input.max)) {
        input.value = currentValue + 1;
      }
    });
  });

  // Handle checkbox groups with max selections
  document.querySelectorAll('.checkbox-group').forEach(function(group) {
    const maxSelections = parseInt(group.dataset.maxSelections);
    const checkboxes = group.querySelectorAll('input[type="checkbox"]');
    const counter = group.closest('.package-form__field').querySelector('.choice-counter');

    function updateCheckboxes() {
      const checked = group.querySelectorAll('input[type="checkbox"]:checked');
      if (counter) {
        counter.style.display = 'inline';
        counter.textContent = `(${checked.length}/${maxSelections})`;
      }

      if (checked.length >= maxSelections) {
        checkboxes.forEach(cb => {
          if (!cb.checked) cb.disabled = true;
        });
      } else {
        checkboxes.forEach(cb => cb.disabled = false);
      }
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updateCheckboxes));
  });

  // Handle sandwich builder
  let sandwichRowCount = {};

  document.querySelectorAll('.sandwich-builder').forEach(function(builder) {
    const blockId = builder.closest('.package-card').querySelector('.package-form').dataset.packageId;
    sandwichRowCount[blockId] = 1;

    updateSandwichBuilder(builder);
  });

  document.querySelectorAll('.add-sandwich-row').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const blockId = btn.dataset.blockId;
      const builder = btn.closest('.sandwich-builder');
      const rowsContainer = builder.querySelector('.sandwich-rows');
      sandwichRowCount[blockId] = (sandwichRowCount[blockId] || 1) + 1;
      const rowNum = sandwichRowCount[blockId];

      const firstRow = rowsContainer.querySelector('.sandwich-row');
      const newRow = firstRow.cloneNode(true);

      // Update row number
      newRow.querySelectorAll('select').forEach(select => {
        select.name = select.name.replace(/_\d+$/, '_' + rowNum);
        select.dataset.row = rowNum;
        select.value = '';
        if (select.classList.contains('sandwich-type-select')) {
          select.disabled = true;
        }
      });

      rowsContainer.appendChild(newRow);

      // Re-attach event listeners
      attachSandwichRowListeners(builder);
    });
  });

  function attachSandwichRowListeners(builder) {
    builder.querySelectorAll('.sandwich-qty-select').forEach(function(qtySelect) {
      qtySelect.removeEventListener('change', handleSandwichQtyChange);
      qtySelect.addEventListener('change', handleSandwichQtyChange);
    });

    builder.querySelectorAll('.sandwich-type-select').forEach(function(typeSelect) {
      typeSelect.removeEventListener('change', handleSandwichTypeChange);
      typeSelect.addEventListener('change', handleSandwichTypeChange);
    });
  }

  function handleSandwichQtyChange(e) {
    const qtySelect = e.target;
    const row = qtySelect.closest('.sandwich-row');
    const typeSelect = row.querySelector('.sandwich-type-select');
    const builder = qtySelect.closest('.sandwich-builder');

    if (qtySelect.value) {
      typeSelect.disabled = false;
    } else {
      typeSelect.disabled = true;
      typeSelect.value = '';
    }

    updateSandwichBuilder(builder, qtySelect);
  }

  function handleSandwichTypeChange(e) {
    const builder = e.target.closest('.sandwich-builder');
    updateSandwichBuilder(builder);
  }

  function updateSandwichBuilder(builder, changedSelect = null) {
    const maxTotal = parseInt(builder.dataset.maxTotal);
    const qtySelects = builder.querySelectorAll('.sandwich-qty-select');
    const totalDisplay = builder.querySelector('.sandwich-total span');

    let total = 0;
    qtySelects.forEach(select => {
      total += parseInt(select.value) || 0;
    });

    // If total exceeds max, auto-adjust other selects
    if (total > maxTotal && changedSelect) {
      let remaining = total - maxTotal;

      // Try to reduce other selects starting from the end
      const selectsArray = Array.from(qtySelects).reverse();
      for (const select of selectsArray) {
        if (select === changedSelect) continue;

        const currentVal = parseInt(select.value) || 0;
        if (currentVal > 0 && remaining > 0) {
          const reduction = Math.min(currentVal, remaining);
          const newVal = currentVal - reduction;
          select.value = newVal > 0 ? newVal : '';

          // Add pulse animation
          select.classList.add('auto-adjusted');
          setTimeout(() => select.classList.remove('auto-adjusted'), 2000);

          // Disable type select if quantity becomes empty
          if (!select.value) {
            const row = select.closest('.sandwich-row');
            const typeSelect = row.querySelector('.sandwich-type-select');
            typeSelect.disabled = true;
            typeSelect.value = '';
          }

          remaining -= reduction;
        }
      }

      // Recalculate total
      total = 0;
      qtySelects.forEach(select => {
        total += parseInt(select.value) || 0;
      });
    }

    totalDisplay.textContent = total;

    // Update available quantities in dropdowns (disable/hide options beyond remaining)
    qtySelects.forEach(select => {
      const currentVal = parseInt(select.value) || 0;
      const remaining = maxTotal - total + currentVal;

      // Disable options based on remaining
      Array.from(select.options).forEach(option => {
        if (option.value === '') return;
        const optionVal = parseInt(option.value);
        option.disabled = optionVal > remaining;
        // Optionally hide disabled options
        if (optionVal > remaining) {
          option.style.display = 'none';
        } else {
          option.style.display = '';
        }
      });
    });
  }

  // Attach initial sandwich listeners
  document.querySelectorAll('.sandwich-builder').forEach(attachSandwichRowListeners);

  // ========================================
  // SKEWER BUILDER FUNCTIONS
  // ========================================

  function attachSkewerBuilderListeners(builder) {
    builder.querySelectorAll('.skewer-qty-select').forEach(function(select) {
      select.removeEventListener('change', handleSkewerQtyChange);
      select.addEventListener('change', handleSkewerQtyChange);
    });
  }

  function handleSkewerQtyChange(e) {
    const select = e.target;
    const builder = select.closest('.skewer-builder');
    updateSkewerBuilder(builder, select);
  }

  function updateSkewerBuilder(builder, changedSelect = null) {
    const maxTotal = parseInt(builder.dataset.maxTotal);
    const qtySelects = builder.querySelectorAll('.skewer-qty-select');
    const totalDisplay = builder.querySelector('.skewer-count');

    let total = 0;
    qtySelects.forEach(select => {
      total += parseInt(select.value) || 0;
    });

    // If total exceeds max, auto-adjust other selects
    if (total > maxTotal && changedSelect) {
      let remaining = total - maxTotal;

      // Try to reduce other selects starting from the end
      const selectsArray = Array.from(qtySelects).reverse();
      for (const select of selectsArray) {
        if (select === changedSelect) continue;

        const currentVal = parseInt(select.value) || 0;
        if (currentVal > 0 && remaining > 0) {
          const reduction = Math.min(currentVal, remaining);
          select.value = currentVal - reduction;

          // Add pulse animation
          select.classList.add('auto-adjusted');
          setTimeout(() => select.classList.remove('auto-adjusted'), 2000);

          remaining -= reduction;
        }
      }

      // Recalculate total
      total = 0;
      qtySelects.forEach(select => {
        total += parseInt(select.value) || 0;
      });
    }

    totalDisplay.textContent = total;

    // Update available quantities in dropdowns (disable/hide options beyond remaining)
    qtySelects.forEach(select => {
      const currentVal = parseInt(select.value) || 0;
      const remaining = maxTotal - total + currentVal;

      // Disable options based on remaining
      Array.from(select.options).forEach(option => {
        const optionVal = parseInt(option.value);
        if (optionVal === 0) return; // Always allow 0

        option.disabled = optionVal > remaining;
        // Hide disabled options
        if (optionVal > remaining) {
          option.style.display = 'none';
        } else {
          option.style.display = '';
        }
      });
    });

    // Update overall upcharge display
    updateOverallUpcharge();
  }

  // Attach initial skewer listeners
  document.querySelectorAll('.skewer-builder').forEach(attachSkewerBuilderListeners);

  // ========================================
  // CART EDIT FUNCTIONALITY
  // ========================================

  // Editable package product handles
  const EDITABLE_PACKAGES = [
    'party-package-small',
    'party-package-large',
    'lunch-package',
    'cocktail-party-package'
  ];

  // Edit session storage (global for access in handleOverlayAddToCart)
  window.packageEditSession = null;

  // Inject Edit buttons into cart drawer
  function injectCartEditButtons() {
    const cartItems = document.querySelectorAll('.cart-item');

    cartItems.forEach(async function(cartItemEl) {
      // Check if Edit button already exists or is being processed
      if (cartItemEl.querySelector('.cart-item__edit') || cartItemEl.dataset.editProcessing) return;

      // Mark as being processed to prevent race conditions
      cartItemEl.dataset.editProcessing = 'true';

      // Get variant ID and properties hash from data attribute
      const cartItemKey = cartItemEl.dataset.cartItem;
      if (!cartItemKey) {
        delete cartItemEl.dataset.editProcessing;
        return;
      }

      // Fetch cart data to get product handle
      try {
        const cartData = await fetch('/cart.js').then(r => r.json());
        const lineItem = cartData.items.find(item => `${item.variant_id}:${item.properties_hash || ''}` === cartItemKey || item.key === cartItemKey);

        if (!lineItem) {
          delete cartItemEl.dataset.editProcessing;
          return;
        }

        // Check if this product handle is in our editable packages list
        const isEditable = EDITABLE_PACKAGES.includes(lineItem.handle);

        if (isEditable && lineItem.properties && Object.keys(lineItem.properties).length > 0) {
          // Create Edit button
          const editBtn = document.createElement('button');
          editBtn.className = 'cart-item__edit';
          editBtn.textContent = 'Edit';
          editBtn.setAttribute('aria-label', 'Edit package customization');
          editBtn.dataset.lineKey = lineItem.key;
          editBtn.dataset.variantId = lineItem.variant_id;
          editBtn.dataset.productHandle = lineItem.handle;

          // Add click handler
          editBtn.addEventListener('click', function(e) {
            e.preventDefault();
            handleEditClick(lineItem);
          });

          // Insert Edit button before Remove button
          const removeBtn = cartItemEl.querySelector('.cart-item__remove');
          if (removeBtn) {
            removeBtn.insertAdjacentElement('beforebegin', editBtn);
          } else {
            const priceDiv = cartItemEl.querySelector('.cart-item__price');
            if (priceDiv) priceDiv.appendChild(editBtn);
          }
        }

        // Remove processing flag after completion
        delete cartItemEl.dataset.editProcessing;
      } catch (error) {
        console.error('Error injecting Edit button:', error);
        delete cartItemEl.dataset.editProcessing;
      }
    });
  }

  // Handle Edit button click
  function handleEditClick(lineItem) {
    // Store edit session
    window.packageEditSession = {
      lineKey: lineItem.key,
      variantId: lineItem.variant_id,
      productHandle: lineItem.handle,
      quantity: lineItem.quantity,
      properties: lineItem.properties
    };

    // Store in sessionStorage for page navigation
    sessionStorage.setItem('packageEditSession', JSON.stringify(window.packageEditSession));

    // Navigate to party packages page if not already there
    if (!window.location.pathname.includes('/pages/party-packages')) {
      window.location.href = '/pages/party-packages';
      return;
    }

    // We're already on the page, open the modal
    openEditModal();
  }

  // Open modal with pre-populated data
  function openEditModal() {
    if (!window.packageEditSession) return;

    // Find the button for this package
    const buttons = document.querySelectorAll('.order-package-btn');
    let targetButton = null;

    buttons.forEach(btn => {
      const variantId = btn.dataset.variantId;
      if (variantId === String(window.packageEditSession.variantId)) {
        targetButton = btn;
      }
    });

    if (!targetButton) {
      showToast('Unable to find package. Please try again.', 'error');
      return;
    }

    // Update session with package name from button (needed for edit cleanup filter)
    window.packageEditSession.packageName = targetButton.dataset.packageName;

    // Open the overlay
    openPackageOrderOverlay(targetButton);

    // Wait for form to be built, then pre-populate
    setTimeout(() => {
      prePopulateForm(window.packageEditSession.properties);
    }, 100);
  }

  // Pre-populate form fields from cart properties
  function prePopulateForm(properties) {
    const form = document.getElementById('overlay-package-form');
    if (!form) return;

    // Iterate through properties and populate fields
    Object.keys(properties).forEach(function(propKey) {
      // Skip internal properties that start with _ or contain Upcharge
      if (propKey.startsWith('_') || propKey.includes('Upcharge')) return;

      const propValue = properties[propKey];

      // Find the field by label
      const fields = form.querySelectorAll('.package-form__field');

      fields.forEach(function(field) {
        // Use data-field-label attribute for matching
        const fieldLabel = field.dataset.fieldLabel;
        if (!fieldLabel) return;

        // Check if this field matches the property key
        // For skewer fields, match partial (e.g., "Choose Skewers (12/12 total)" matches "Choose Skewers")
        const isMatch = fieldLabel === propKey ||
                       propKey.startsWith(fieldLabel) ||
                       (fieldLabel.includes('Skewers') && propKey.includes('Skewers'));

        if (isMatch) {
          const fieldType = field.dataset.fieldType;

          if (fieldType === 'select') {
            // Simple select dropdown
            const select = field.querySelector('select');
            if (select) select.value = propValue;
          }
          else if (fieldType === 'tapas-platter') {
            // Tapas selections - inline selector
            const hiddenInput = field.querySelector('.tapas-selections-input');
            const inlineSelector = field.querySelector('.tapas-inline-selector');

            if (hiddenInput && inlineSelector) {
              // Parse the selections (may include quantities like "Tzatziki (2)")
              const selections = propValue.split(', ').map(s => s.trim());

              // Find the selector's instance and populate it
              const tapasItems = inlineSelector.querySelectorAll('.tapas-inline-item');

              // Build selected items array
              const selectedItems = [];
              selections.forEach(function(selection) {
                // Check if selection has quantity notation like "Tzatziki (2)"
                const match = selection.match(/^(.+?)\s*\((\d+)\)$/);
                let tapasName, quantity;

                if (match) {
                  tapasName = match[1].trim();
                  quantity = parseInt(match[2]);
                } else {
                  tapasName = selection;
                  quantity = 1;
                }

                // Find matching item to get color/shape, and add it quantity times
                tapasItems.forEach(function(item) {
                  if (item.dataset.tapas === tapasName) {
                    for (let i = 0; i < quantity; i++) {
                      selectedItems.push({
                        name: tapasName,
                        color: item.dataset.color,
                        shape: item.dataset.shape
                      });
                    }
                  }
                });
              });

              // Store in data attribute for the selector to pick up
              inlineSelector.dataset.preselected = JSON.stringify(selectedItems);

              // Set hidden input
              hiddenInput.value = propValue;

              // Trigger a re-render by dispatching a custom event
              inlineSelector.dispatchEvent(new CustomEvent('tapas-preload'));
            }
          }
          else if (fieldType === 'skewer-builder') {
            // Parse skewer selections like "Chicken Skewers (5), Salmon Skewers (7)"
            const selections = propValue.split(', ');
            const inputs = field.querySelectorAll('.skewer-qty-select');

            selections.forEach(function(selection) {
              const match = selection.match(/^(.+?)\s*\((\d+)\)$/);
              if (match) {
                const optionName = match[1].trim();
                const quantity = parseInt(match[2]);

                inputs.forEach(function(input) {
                  if (input.dataset.optionName === optionName) {
                    input.value = quantity;
                    // Trigger change event to update totals
                    input.dispatchEvent(new Event('change'));
                  }
                });
              }
            });
          }
          else if (fieldType === 'sandwich-builder') {
            // Parse sandwich selections like "Kashkaval Sandwich (10), Curry Chicken Sandwich (10)"
            const selections = propValue.split(', ');
            const builder = field.querySelector('.sandwich-builder');
            const rowsContainer = builder.querySelector('.sandwich-rows');

            // Clear existing rows except first
            const allRows = rowsContainer.querySelectorAll('.sandwich-row');
            for (let i = allRows.length - 1; i > 0; i--) {
              allRows[i].remove();
            }

            selections.forEach(function(selection, index) {
              const match = selection.match(/^(.+?)\s*\((\d+)\)$/);
              if (match) {
                const sandwichType = match[1].trim();
                const quantity = match[2];

                // Get or create row
                let row;
                if (index === 0) {
                  row = rowsContainer.querySelector('.sandwich-row');
                } else {
                  // Clone first row
                  const firstRow = rowsContainer.querySelector('.sandwich-row');
                  row = firstRow.cloneNode(true);
                  rowsContainer.appendChild(row);
                }

                // Set values
                const qtySelect = row.querySelector('.sandwich-qty-select');
                const typeSelect = row.querySelector('.sandwich-type-select');

                if (qtySelect) qtySelect.value = quantity;
                if (typeSelect) {
                  typeSelect.disabled = false;
                  typeSelect.value = sandwichType;
                }
              }
            });

            // Update totals
            updateSandwichBuilder(builder);
          }
          else if (fieldType === 'multiselect') {
            // Checkboxes - parse comma-separated values
            const values = propValue.split(', ').map(v => v.trim());
            const checkboxes = field.querySelectorAll('input[type="checkbox"]');

            checkboxes.forEach(function(cb) {
              if (values.includes(cb.value)) {
                cb.checked = true;
              }
            });
          }
          else if (fieldType === 'quantity') {
            // Parse quantity selections like "Option 1 (3), Option 2 (5)"
            const selections = propValue.split(', ');
            const inputs = field.querySelectorAll('input[type="number"]');

            selections.forEach(function(selection) {
              const match = selection.match(/^(.+?)\s*\((\d+)\)$/);
              if (match) {
                const optionName = match[1].trim();
                const quantity = parseInt(match[2]);

                inputs.forEach(function(input) {
                  if (input.dataset.optionName === optionName) {
                    input.value = quantity;
                    input.dispatchEvent(new Event('change'));
                  }
                });
              }
            });
          }
          else if (fieldType === 'dropdown-sequence') {
            // Value format: "Salad One: Kale Salad, Salad Two: Greek Salad"
            const parts = propValue.split(', ');
            const selects = field.querySelectorAll('.dropdown-sequence select');
            selects.forEach(function(select, index) {
              if (parts[index]) {
                const colonIdx = parts[index].indexOf(': ');
                select.value = colonIdx !== -1 ? parts[index].slice(colonIdx + 2) : parts[index];
              }
            });
          }
        }
      });
    });

    // Set quantity if stored
    if (window.packageEditSession.quantity) {
      const qtyInput = document.getElementById('overlay-quantity');
      if (qtyInput) qtyInput.value = window.packageEditSession.quantity;
    }
  }

  // Check for edit session on page load
  const savedEditSession = sessionStorage.getItem('packageEditSession');
  if (savedEditSession && window.location.pathname.includes('/pages/party-packages')) {
    try {
      window.packageEditSession = JSON.parse(savedEditSession);
      // Open modal after page loads
      setTimeout(() => {
        openEditModal();
      }, 500);
    } catch (error) {
      console.error('Error loading edit session:', error);
      sessionStorage.removeItem('packageEditSession');
    }
  }

  // Inject Edit buttons when cart drawer opens or updates
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    // Use MutationObserver to detect when cart drawer opens or content changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
          if (isOpen) {
            setTimeout(injectCartEditButtons, 200);
          }
        }
        if (mutation.type === 'childList') {
          setTimeout(injectCartEditButtons, 200);
        }
      });
    });

    observer.observe(cartDrawer, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // Also inject on initial load if cart is already open
    if (cartDrawer.getAttribute('aria-hidden') === 'false') {
      setTimeout(injectCartEditButtons, 500);
    }
  }

});
